export * from './sfaPenaltiesStrip.types';
export { default as SfaPenaltiesStrip } from './sfaPenaltiesStrip.component';
